import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API, fileUpload } from "../../config";
import { Button } from "../../components/ui/button";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";

import { Loader2, Trash2 } from "lucide-react";
import { Input } from "../../components/ui/input";
import { getContractDetail } from "./ContractHelper";
import Spin from "../../components/Spin";
// import { AddContractSchema } from "../../lib/Validation";
import { AssetList, SubAssetList, VendorList } from "../../lib/OptionsAPI";
import VendorSelect from "../../components/VendorSelect";
import AssetSelect from "../../components/AssetSelect";
import SubAssetSelect from "../../components/SubAssetSelect";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { defaultBaseUrl } from "../../APIConfig/Interceptor";
import { cn } from "../../lib/utils";
import {
  formatSubcontractorName,
  getModuleNamingBySlug,
  MaxLimit,
} from "../../lib/Misc";
import { NumericFormat } from "react-number-format";
import { toast } from "../../components/ui/use-toast";
import { AddContractSchema } from "../../lib/Validation";
import { DateInputPicker } from "../../components/DateInputPicker";
import moment from "moment";
import { Checkbox } from "../../components/ui/checkbox";
import { useOrganization } from "../../lib/context/OrganisationContext";

const AddEditContract = ({
  edit,
  contractID,
  toggleShowAddEditContract,
  fetchContracts,
  trustId,
}) => {
  const { id } = useParams();
  const { organizationData } = useOrganization();
  const [contractData, setContractData] = useState();
  const [loading, setLoading] = useState(false);
  const contractId = contractID ? contractID : id;

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorId, setVendorId] = useState();

  const [assetLoading, setAssetLoading] = useState(false);
  const [assetListing, setAssetListing] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [assetId, setAssetId] = useState();

  const [subAssetLoading, setSubAssetLoading] = useState(false);
  const [subAssetListing, setSubAssetListing] = useState([]);
  const [subAssetList, setSubAssetList] = useState([]);
  const [subAssetId, setSubAssetId] = useState();

  const handleView = async (value) => {
    window.open(`${value}`, "_blank", "noreferrer");
  };

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getContractDetail(contractId);
      if (data?.vendor_id) {
        FetchVendorList();
        setVendorId(data?.vendor_id);
        if (data?.vendor) {
          setVendorList([
            data?.vendor
              ? {
                  ...data?.vendor,

                  value: data?.vendor?.id,
                  label:
                    data?.vendor.first_name +
                    `${
                      data?.vendor?.last_name
                        ? ` ${data?.vendor?.last_name}`
                        : ""
                    }${data?.vendor?.code ? ` (${data?.vendor?.code})` : ""}`,
                }
              : {},
          ]);
        }
      }
      if (data?.asset_id) {
        FetchAssetList();
        setAssetId(data?.asset_id);
        if (data?.asset) {
          setAssetList([
            data?.asset
              ? {
                  ...data?.asset,

                  value: data?.asset?.id,
                  label: data?.asset?.name
                    ? `${data?.asset?.name}${
                        data?.asset?.code ? ` (${data?.asset?.code})` : ""
                      }`
                    : "",
                }
              : {},
          ]);
        }
      }

      if (data?.sub_asset_id) {
        FetchSubAssetList();
        setSubAssetId(data?.sub_asset_id);
        if (data?.sub_asset) {
          setSubAssetList([
            data?.sub_asset
              ? {
                  ...data?.sub_asset,

                  value: data?.sub_asset?.id,
                  label: data?.sub_asset?.name
                    ? `${data?.sub_asset?.name}${
                        data?.sub_asset?.code
                          ? ` (${data?.sub_asset?.code})`
                          : ""
                      }`
                    : "",
                }
              : {},
          ]);
        }
      }
      // if (data?.contact_id) {
      //   FetchContactList();
      //   if (data?.contact ? data?.contact : false) {
      //     setContactList([
      //       data?.contact
      //         ? {
      //             ...data?.contact,
      //             value: data?.contact.id,
      //             label: formatSubcontractorName(data?.contact),
      //           }
      //         : {},
      //     ]);
      //   }

      //   if (data?.contract_id ? data?.contract_id : false) {
      //     FetchContractList(data?.contact_id);
      //     if (data?.contract ? data?.contract : false) {
      //       setContractList([
      //         data?.contract
      //           ? {
      //               ...data?.contract,
      //               value: data?.contract.id,
      //               label: data?.contract?.contract_number,
      //             }
      //           : {},
      //       ]);
      //     }
      //   }
      // }
      setContractData(data);
      setLoading(false);
    } catch (e) {
      setContractData(null);
    }
  }

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    formData.append("trust_id", trustId);

    value.contract_value = Number(`${value.contract_value}`.replace(/,/g, ""));
    value.contract_value_exc = Number(
      `${value.contract_value_exc}`.replace(/,/g, "")
    );

    formData.append("vendor_id", value?.vendor_id ? value?.vendor_id : "");

    formData.append("asset_id", value?.asset_id ? value?.asset_id : "");

    formData.append(
      "sub_asset_id",
      value?.sub_asset_id ? value?.sub_asset_id : ""
    );

    formData.append(
      `contract_number`,
      value.contract_number ? value.contract_number : ""
    );

    formData.append(
      `contract_value`,
      value.contract_value ? value.contract_value : ""
    );
    formData.append(
      `contract_value_exc`,
      value.contract_value_exc ? value.contract_value_exc : ""
    );
    formData.append(
      `contract_file`,
      value.contract_file ? value.contract_file : ""
    );

    formData.append(
      "start_date",
      value?.start_date ? moment(value?.start_date).format("DD-MM-YYYY") : ""
    );
    formData.append(
      "end_date",
      value?.end_date ? moment(value?.end_date).format("DD-MM-YYYY") : ""
    );

    formData.append("auto_renewal", value?.auto_renewal ? 1 : 0);

    if (contractId) {
      formData.append("_method", "put");
    }

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.CONTRACT_ADD}${contractId ? `/${contractId}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditContract();
        fetchContracts && fetchContracts();
      }
      return data?.data;
    } catch (error) {
      setContractData(value);
      setLoading(false);
    }
  };

  const FetchVendorList = async () => {
    await VendorList(
      organizationData,
      trustId,
      1,
      setVendorLoading,
      setVendorList,
      true
    );
  };

  const FetchAssetList = async () => {
    await AssetList(
      organizationData,
      trustId,
      vendorId,
      1,
      setAssetLoading,
      setAssetList,
      true
    );
  };

  const FetchSubAssetList = async () => {
    await SubAssetList(
      organizationData,
      trustId,
      assetId,
      "",
      1,
      setSubAssetLoading,
      setSubAssetList,
      true
    );
  };

  // const FetchContactList = async () => {
  //   await ContactList(trustId, 1, setContactLoading, setContactList, true);
  // };

  // const FetchContractList = async (contactId) => {
  //   await ContractList(
  //     trustId,
  //     contactId,
  //     1,
  //     setContractLoading,
  //     setContractList,
  //     true
  //   );
  // };

  // useEffect(() => {
  //   if (contactList) {
  //     let contactTempListing = contactList?.map((item) => ({
  //       ...item,
  //       value: item.id,
  //       label: formatSubcontractorName(item),
  //     }));
  //     setContactListing(contactTempListing || []);
  //   } else {
  //     setContactListing([]);
  //   }
  // }, [contactList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? `(${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (assetList) {
      let assetTempListing = assetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name
          ? `${item.name}${item?.code ? ` (${item?.code})` : ""}`
          : "",
      }));
      setAssetListing(assetTempListing || []);
    } else {
      setAssetListing([]);
    }
  }, [assetList]);

  useEffect(() => {
    if (subAssetList) {
      let subAssetTempListing = subAssetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name
          ? `${item.name}${item?.identifier ? ` (${item?.identifier})` : ""}`
          : "",
      }));
      setSubAssetListing(subAssetTempListing || []);
    } else {
      setSubAssetListing([]);
    }
  }, [subAssetList]);

  return (
    <Formik
      initialValues={{
        vendor_id: contractData?.vendor_id,
        asset_id: contractData?.asset_id,
        sub_asset_id: contractData?.sub_asset_id,
        contract_number: contractData?.contract_number
          ? contractData?.contract_number
          : "",
        contract_value: contractData?.contract_value
          ? contractData?.contract_value
          : "",
        contract_value_exc: contractData?.contract_value_exc
          ? contractData?.contract_value_exc
          : "",
        contract_file: contractData?.contract_file
          ? contractData?.contract_file
          : "",
        start_date: contractData?.start_date
          ? new Date(moment(contractData?.start_date, "DD-MM-YYYY").toDate())
          : "",
        end_date: contractData?.end_date
          ? new Date(moment(contractData?.end_date, "DD-MM-YYYY").toDate())
          : "",
        auto_renewal: contractData?.auto_renewal === 1 ? true : false,
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddContractSchema(organizationData)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setTouched,
        validateField,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden p-4 border rounded-lg">
              <div className="grid gap-4">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="sub_asset_id">
                      <CustomLabelText
                        labelText={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "sub-assets",
                          "Sub Asset"
                        )}
                        required={true}
                        errorField={errors?.sub_asset_id}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative">
                      <SubAssetSelect
                        trustId={trustId}
                        assetId={assetId ? assetId : ""}
                        frameworkData={subAssetListing} // List of vendors
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "sub-assets",
                          "Sub Asset"
                        )}
                        handleSelect={(e) => {
                          let subAssetData = subAssetListing?.find(
                            (item) => item.value === e
                          );
                          setSubAssetId(e);
                          setFieldValue("sub_asset_id", e);

                          setTimeout(() => {
                            setTouched({ sub_asset_id: true });
                            validateField("sub_asset_id");
                          }, 0);

                          setTimeout(() => {
                            setTouched({ asset_id: true });
                            validateField("asset_id");
                          }, 0);

                          setFieldValue("asset_id", subAssetData?.asset_id);
                          setAssetId(subAssetData?.asset_id);
                          setAssetListing([
                            {
                              ...subAssetData?.asset,
                              label: subAssetData?.asset?.name
                                ? `${subAssetData?.asset.name}${
                                    subAssetData?.asset?.code
                                      ? ` (${subAssetData?.asset?.code})`
                                      : ""
                                  }`
                                : "",
                              value: subAssetData?.asset_id
                                ? subAssetData?.asset_id
                                : "",
                            },
                          ]);
                          setAssetList([subAssetData?.asset]);

                          setFieldValue("vendor_id", subAssetData?.vendor_id);
                          setVendorId(subAssetData?.vendor_id);
                        }}
                        name="sub_asset_id"
                        // disabled={assetId ? false : true}
                        disabled={false}
                        initialValue={subAssetId ? subAssetId : ""}
                        setSubAssetList={setSubAssetList} // Update vendor list as new data loads
                        setSubAssetLoading={setSubAssetLoading} // Control loading state
                        onClear={() => {
                          setSubAssetId();
                          setFieldValue("sub_asset_id", "");
                          setFieldValue("asset_id", "");
                          setFieldValue("vendor_id", "");

                          setTimeout(() => {
                            setTouched({ sub_asset_id: true });
                            validateField("sub_asset_id");
                          }, 0);

                          setTimeout(() => {
                            setTouched({ asset_id: true });
                            validateField("asset_id");
                          }, 0);
                          setAssetId();
                          setAssetListing([]);
                          setAssetList([]);

                          setVendorId();
                          setVendorListing([]);
                          setVendorList([]);
                        }}
                        className={
                          errors?.sub_asset_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        loading={subAssetLoading}
                      />
                      {subAssetLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="asset_id">
                      <CustomLabelText
                        labelText={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "assets",
                          "Asset"
                        )}
                        required={true}
                        errorField={errors?.asset_id}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative">
                      <AssetSelect
                        trustId={trustId}
                        vendorId={vendorId ? vendorId : ""}
                        frameworkData={assetListing} // List of vendors
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "assets",
                          "Asset"
                        )}
                        handleSelect={(e) => {
                          setAssetId(e);
                          setFieldValue("asset_id", e);
                          setFieldValue("sub_asset_id", "");
                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }}
                        name="asset_id"
                        // disabled={vendorId ? false : true}
                        disabled={true}
                        initialValue={assetId ? assetId : ""}
                        setAssetList={setAssetList} // Update vendor list as new data loads
                        setAssetLoading={setAssetLoading} // Control loading state
                        onClear={() => {
                          setAssetId();
                          setFieldValue("asset_id", "");
                          setFieldValue("sub_asset_id", "");
                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }}
                        loading={assetLoading}
                        className={
                          errors?.asset_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {assetLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="vendor_id">
                      <CustomLabelText
                        labelText={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor"
                        )}
                        required={true}
                        errorField={errors?.vendor_id}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative">
                      <VendorSelect
                        trustId={trustId}
                        frameworkData={vendorListing} // List of vendors
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor"
                        )}
                        handleSelect={(e) => {
                          setVendorId(e);
                          setFieldValue("vendor_id", e);
                          setFieldValue("asset_id", "");
                          setFieldValue("sub_asset_id", "");
                          setAssetListing([]);
                          setAssetList([]);
                          setAssetId();
                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }}
                        name="vendor_id"
                        // disabled={false}
                        disabled={true}
                        initialValue={vendorId ? vendorId : ""}
                        setVendorList={setVendorList} // Update vendor list as new data loads
                        setVendorLoading={setVendorLoading} // Control loading state
                        onClear={() => {
                          setVendorId();
                          setFieldValue("vendor_id", "");
                          setFieldValue("asset_id", "");
                          setFieldValue("sub_asset_id", "");
                          setAssetListing([]);
                          setAssetList([]);
                          setAssetId();

                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }}
                        loading={vendorLoading}
                        className={
                          errors?.vendor_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {vendorLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="contract_number">
                      <CustomLabelText
                        required={true}
                        labelText="Agreement/Contract Number"
                        errorField={errors?.contract_number}
                      />
                    </Label>
                    <Input
                      type="text"
                      name={`contract_number`}
                      value={
                        values.contract_number ? values.contract_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.contract_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="contract_value">
                      <CustomLabelText
                        required={true}
                        labelText="Agreement/Contract Value ($)"
                        errorField={errors?.contract_value}
                      />
                    </Label>

                    <NumericFormat
                      type="text"
                      name={`contract_value`}
                      value={values?.contract_value}
                      onChange={handleChange}
                      onBlur={(e) => {
                        if (e?.target?.value === "") {
                          setFieldValue(`contract_value_exc`, "");
                        } else {
                          let contract_value_exc = Number(
                            Number(
                              Number(e?.target?.value?.replace(/,/g, "")) / 1.1
                            ).toFixed(2)
                          );
                          setFieldValue(
                            `contract_value_exc`,
                            contract_value_exc
                          );
                        }

                        setTimeout(() => {
                          setTouched(
                            {
                              [`contract_value`]: true,
                            },
                            true
                          );
                          validateField(`contract_value`);
                        }, 0);

                        setTimeout(() => {
                          setTouched(
                            {
                              [`contract_value_exc`]: true,
                            },
                            true
                          );
                          validateField(`contract_value_exc`);
                        }, 0);
                        setFieldValue(`contract_value`, e?.target?.value);
                      }}
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={true}
                      isAllowed={(values) => MaxLimit(values)}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.contract_value
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="contract_value_exc">
                      <CustomLabelText
                        required={true}
                        labelText="Agreement / Contract Value(Ex. GST)"
                        errorField={errors?.contract_value_exc}
                      />
                    </Label>

                    <NumericFormat
                      type="text"
                      name={`contract_value_exc`}
                      value={values?.contract_value_exc}
                      onChange={handleChange}
                      onBlur={(e) => {
                        if (e?.target?.value === "") {
                          setFieldValue(`contract_value`, "");
                        } else {
                          let contract_value = Number(
                            Number(
                              Number(e?.target?.value?.replace(/,/g, "")) +
                                Number(e?.target?.value?.replace(/,/g, "")) *
                                  0.1
                            ).toFixed(2)
                          );
                          setFieldValue(`contract_value`, contract_value);
                        }
                        setTimeout(() => {
                          setTouched(
                            {
                              [`contract_value`]: true,
                            },
                            true
                          );
                          validateField(`contract_value`);
                        }, 0);

                        setTimeout(() => {
                          setTouched(
                            {
                              [`contract_value_exc`]: true,
                            },
                            true
                          );
                          validateField(`contract_value_exc`);
                        }, 0);
                        setFieldValue(`contract_value_exc`, e?.target?.value);
                      }}
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={true}
                      isAllowed={(values) => MaxLimit(values)}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.contract_value_exc
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )
                      }
                    />
                  </div>
                  {!values?.contract_file && (
                    <div className="grid gap-2">
                      <Label htmlFor="contract_file">
                        <CustomLabelText
                          required={false}
                          labelText="Agreement / Contract File"
                          errorField={errors?.contract_file}
                        />
                      </Label>{" "}
                      <Input
                        id="contract_file"
                        type="file"
                        name="contract_file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,image/jpeg,image/jpg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={(e) => {
                          const file = e.target.files?.[0];

                          const allowedTypes = [
                            "application/pdf",
                            "application/msword",
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                          ];

                          if (file && allowedTypes.includes(file.type)) {
                            setFieldValue("contract_file", file);
                          } else {
                            e.target.value = "";
                            toast({
                              variant: "destructive",
                              description:
                                "Please upload .pdf, .doc, .docx, .xls, .xlsx, .jpeg, .jpg or .png files only.",
                              duration: 3000,
                            });
                          }
                        }}
                        onBlur={handleBlur}
                        className={
                          errors?.contract_file &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  )}
                  {values?.contract_file && (
                    <div className="grid gap-2">
                      <Label htmlFor="contract_file">
                        <CustomLabelText
                          required={false}
                          labelText="Agreement / Contract File"
                          errorField={errors?.contract_file}
                        />
                      </Label>{" "}
                      <p className="flex items-center justify-between h-9 w-full rounded-md border border-input bg-transparent px-3 py-1">
                        {values.contract_file?.name ? (
                          <span
                            className="truncate max-w-[220px] whitespace-nowrap overflow-hidden"
                            title={values.contract_file?.name}
                          >
                            {values.contract_file?.name}
                          </span>
                        ) : values.contract_file?.includes(defaultBaseUrl()) ? (
                          <span
                            onClick={() => {
                              values.contract_file &&
                                handleView(values.contract_file);
                            }}
                            className="truncate max-w-[220px] whitespace-nowrap overflow-hidden"
                            title={
                              values.contract_file?.split("/")?.slice(-1)[0]
                            }
                          >
                            {values.contract_file?.split("/")?.slice(-1)[0]}
                          </span>
                        ) : (
                          <span
                            onClick={() => {
                              values.contract_file &&
                                handleView(values.contract_file);
                            }}
                            className="truncate max-w-[220px] whitespace-nowrap overflow-hidden"
                          >
                            Open Link{" "}
                          </span>
                        )}
                        <div className="flex items-center gap-1">
                          <AnimatedTooltip title={"Delete File"}>
                            <Trash2
                              size={15}
                              className="fill-primary"
                              onClick={() => {
                                setFieldValue(`contract_file`, "");
                              }}
                            />{" "}
                          </AnimatedTooltip>
                        </div>
                      </p>
                    </div>
                  )}
                  <div className="grid gap-2">
                    <Label htmlFor="start_date">
                      <CustomLabelText
                        required={false}
                        labelText="Start Date"
                        errorField={errors?.start_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={values?.start_date ? values?.start_date : ""}
                      onSelect={(e) => {
                        setFieldValue("start_date", e);
                      }}
                      className={""}
                      disabledDate={{ after: new Date() }}
                      inputClassName="w-full"
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="end_date">
                      <CustomLabelText
                        required={false}
                        labelText="End Date"
                        errorField={errors?.end_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={values?.end_date ? values?.end_date : ""}
                      onSelect={(e) => {
                        setFieldValue("end_date", e);
                      }}
                      futureYear={true}
                      className={""}
                      inputClassName="w-full"
                    />
                  </div>
                  <div className="flex items-center space-x-2 mt-4">
                    <Checkbox
                      id="terms"
                      checked={values?.auto_renewal}
                      name="same_address"
                      onClick={() =>
                        setFieldValue("auto_renewal", !values?.auto_renewal)
                      }
                    />
                    <label
                      htmlFor="terms"
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      Auto Renewal
                    </label>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditContract();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditContract;
